import { render, staticRenderFns } from "./choose.vue?vue&type=template&id=0a71d1e9&scoped=true&"
import script from "./choose.vue?vue&type=script&lang=ts&"
export * from "./choose.vue?vue&type=script&lang=ts&"
import style0 from "./choose.vue?vue&type=style&index=0&id=0a71d1e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a71d1e9",
  null
  
)

export default component.exports